<template>
  <div class="table-page-wrapper">

    <div v-show="searchStatus" class="search-wrapper">
      <el-input v-model="tableParams.searchKey"  placeholder="广告位编号/名称" />
      <search-channel-app-select v-model="tableParams.appId" />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        style="padding-bottom: 10px;">
        <el-button @click="add" type="primary" size="small">新增</el-button>
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        :header-cell-style="{background:'#fafafa'}"
        highlight-current-row
        size="small"
        class="js-table"
        style="width: 100%">
          <el-table-column
            v-for="(v, i) in checkColumns"
            :prop="v.field"
            :label="v.title"
            :width="v.width"
            :min-width="v.minWidth"
            :key="i"
            align="center">
            <template v-slot="scope">
              <span v-if="v.field === 'appType'">{{ appTypeMap[scope.row[v.field]] || '-' }}</span>
              <span v-else-if="v.field==='budgetNameIdList'&&scope.row[v.field]">
                {{scope.row[v.field].map(item=>{return item.budgetName}).join(',')}}
              </span>
              <span v-else-if="v.field === 'slotTypeId'">{{ slotTypeMap[scope.row[v.field]] || '-' }}</span>

              <span v-else-if="v.field === 'size'">{{scope.row.customizeSize||scope.row.slotSize}}</span>
              <span v-else-if="v.field === 'billingType'">{{ billingTypeMap[scope.row[v.field]] || '-' }}</span>
              <span v-else-if="v.field === 'settlementType'">{{ settlementTypeMap[scope.row[v.field]] || '-' }}</span>
              <span v-else-if="v.field === 'isDownload'">{{ scope.row[v.field] ? '否' : '是' }}</span>
              <span v-else-if="v.field === 'isDp'">{{ scope.row[v.field] ? '否' : '是' }}</span>
              <template v-else-if="v.field === 'imageUrl'">
                <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
                ref="popover">
                <template #reference >
                <img v-if="scope.row[v.field]" :src="$imgURL + scope.row[v.field]" style="height: 30px;" alt="广告截图" />
                <span v-else>-</span>
                </template>
                <img v-if="scope.row[v.field]" :src="$imgURL + scope.row[v.field]" style="height: 200px;" alt="广告截图" />
              </el-popover>
              </template>
              <span v-else-if="v.field === 'isEnable'">{{ statusMap[scope.row[v.field]] || '-' }}</span>
              <span v-else>{{ scope.row[v.field]||'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="100">
            <template v-slot="scope" align="center">
              <el-button @click="update(scope.row)" type="success" :disabled="scope.row.isEnable==0" size="mini">编辑</el-button>
            </template>
          </el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px;" />
    </div>

    <m-form @submit="toQuery" ref="form"/>

  </div>
</template>

<script>
import SearchSlotTypeSelect from '@/components/SearchSlotTypeSelect'
import SearchChannelAppSelect from '@/components/SearchChannelAppSelect'
import TableColumn from '@/components/TableColumn'
import mForm from './form'
import initTableMixin from '@/mixins/initTable'
import { appTypeMap } from '@/const/app-type'
import { slotTypeMap } from '@/const/slot-type'
import { billingTypeMap } from '@/const/billing-type'
import { settlementTypeMap } from '@/const/settlement-type'

export default {
  name: 'mediaAppAd',
  components: {
    SearchSlotTypeSelect,
    SearchChannelAppSelect,
    TableColumn,
    mForm
  },
  mixins: [initTableMixin],
  data () {
    return {
      appTypeMap,
      slotTypeMap,
      billingTypeMap,
      settlementTypeMap,
      columns: [
        { field: 'appId', title: '应用编号列' },
        { field: 'appName', title: '应用名称' },
        { field: 'slotId', title: '广告位编号' },
        { field: 'slotName', title: '广告名称' },
        { field: 'appType', title: '操作系统' },
        { field: 'budgetNameIdList', title: '预算类型' },
        { field: 'slotTypeId', title: '广告位类型' },
        { field: 'size', title: '已选广告尺寸' },
        { field: 'billingType', title: '计费方式' },
        { field: 'settlementType', title: '结算方式' },
        { field: 'slotPv', title: '访问量(PV)' },
        { field: 'lowPrice', title: '广告底价' },
        { field: 'isDownload', title: '支持下载' },
        { field: 'isDp', title: '支持dp上报' },
        { field: 'imageUrl', title: '广告截图' },
        { field: 'isEnable', title: '审核状态' },
        { field: 'createTime', title: '创建时间' }
      ],
       statusMap: {
        0: '审核通过',
        1: '未通过',
        2: '未审核'
      },
    }
  },
  created () {},
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    beforeInit () {
      this.tableUrl = '/slot/channel/list'
      return true
    },
    add () {
      this.$refs.form.show()
    },
    update (row) {
      this.$refs.form.show(row)
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper{
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;
  &>*{
    margin-right: 15px;
    margin-bottom: 10px;
    &:last-child{
      margin-right: 0;
    }
  }

  &>.el-select,&>.el-input{
    width: 220px;
  }
}

.table-wrapper{
  padding: 15px;
  background: #ffffff;
  .table__operation{
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}
</style>
